import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getFleetAverage } from '../actions/fleetAverageAction';


export interface VesselDetail {
  shipId: number;
  shipName: string;
  shipType: string;
  averageRecovery: number;
  averageStrain: number;
  averageSleep: number;
  startDate: Date;
  endDate: Date;
}

export interface FleetDetails {
  data: VesselDetail[];
  selectedVessel: VesselDetail | undefined;
  loading: boolean;
  error: string | null;
}

const initialState: FleetDetails = {
  data: [],
  selectedVessel: undefined,
  loading: false,
  error: '',
};

const averageFleetSlice = createSlice({
  name: 'averageFleetDetails',
  initialState: initialState,
  reducers: {
    averageFleetDetails: (state: FleetDetails, action: PayloadAction<VesselDetail[]>) => { 
      state.data = action.payload;
    },
    setSelectedVessel: (state: FleetDetails, action: PayloadAction<string>) => {
      state.selectedVessel = action.payload ? state.data.filter(v => v.shipName === action.payload)[0] : undefined;
    }
  },
  extraReducers: (builder) => {
    // load averageFleetDetails
    builder.addCase(getFleetAverage.pending, (state: FleetDetails) => {
        state.loading = true
        state.error = null
    }),
    builder.addCase(getFleetAverage.fulfilled, (state: FleetDetails, { payload }: PayloadAction<VesselDetail[]>) => {
        state.loading = false
        state.data = payload
    }),
    builder.addCase(getFleetAverage.rejected, (state: FleetDetails, { payload }: PayloadAction<any>) => {
        state.loading = false
        state.error = payload
    })
  }
});

export const { averageFleetDetails, setSelectedVessel } = averageFleetSlice.actions;

export default averageFleetSlice.reducer;